<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.walking.ability' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <fieldset
          class="p-support-info__radio"
          role="radiogroup"
          [attr.aria-required]="true"
          attr.aria-describedby="{{ error !== null ? 'support-information-p-support-info__radio_error' : '' }}"
          [attr.aria-invalid]="error !== null"
        >
          <legend class="p-support-info__radio-legend" [innerHTML]="'label.walking.ability' | staticMsg"></legend>
          <div class="p-support-info__radio-list">
            <div *ngFor="let item of master; index as i" class="p-support-info__radio-item">
              <input
                type="radio"
                name="radio1"
                id="support-information-input-walking-ability-radio_{{ i }}"
                class="p-support-info__radio-item-input"
                [checked]="code === item.code"
                (change)="changeCode(item.code)"
              />
              <label
                for="support-information-input-walking-ability-radio_{{ i }}"
                class="p-support-info__radio-item-label"
              >
                <span class="p-support-info__radio-item-check"></span>
                <span class="p-support-info__radio-item-text-wrap">
                  <span class="p-support-info__radio-item-text">
                    {{ item.name }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </fieldset>
        <asw-validation-error
          *ngIf="error !== null"
          id="support-information-p-support-info__radio_error"
          [errorMessage]="error"
        ></asw-validation-error>
      </div>
    </div>
  </div>
</div>
